import { applog } from '../domain/utils/applog';

export class CurrencyUtils {
    static removeCurrency(currencyString: string): number {
        if (!currencyString) return 0.0;

        let withoutCurrency = currencyString
            .replace("S/", "")
            .replace(",", "")
            .replace(" ", "");

        applog('Currency', withoutCurrency);
        return parseFloat(withoutCurrency);
    }

    static moneyFormat(amount: number): string {
        const numberFormatted = new Intl.NumberFormat('es-PE', {
            style: 'currency',
            currency: 'PEN',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(amount);

        return numberFormatted; // Ejemplo: "S/ 1,234.56"
    }
}
